import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import LandingPage from './components/LandingPage';
import Reader from './components/Reader';
import Article from './components/Article';
import NotFound from './components/NotFound';
import reportWebVitals from './reportWebVitals';
import HandSeals from './components/HandSeals';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<Article />} />
        <Route path="/:chapterSlug/:partSlug" element={<Reader />} />
        <Route path="/:chapterSlug" element={<Reader />} />
        <Route path="/articles/:articleSlug" element={<Article />} />
        <Route path="/compendium" element={<Navigate to="/compendium/handseals" replace />} />
        <Route path="/compendium/handseals" element={<HandSeals />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
